/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { DomainTokensServiceRepositoryImpl } from '../impls/DomainTokensServiceRepositoryImpl';
import { IDomainTokensService } from '../interfaces/IDomainTokensService';
import { TDomainTokensResponse } from '../types/TDomainTokensResponse';
import { TServicesParams } from '../types';

export class DomainTokensService implements IDomainTokensService {
    private static TAG: string = 'DomainTokensService';

    private mServiceParams: TServicesParams;

    public constructor(params: TServicesParams) {
        this.mServiceParams = params;
    }

    public async fetchScopedDomainTokens(
        domain: string,
        authorization: string,
    ): Promise<TDomainTokensResponse> {
        return new DomainTokensServiceRepositoryImpl(this.mServiceParams).fetchScopedDomainTokens(
            domain,
            authorization,
        );
    }
}
